import reducer from './settings';
import { actionCreators, SettingsActionType } from './settings.actionCreators';
import * as actionTypes from './settings.actionTypes';

export * from './settings'; // expose all types
export * from './settings.selectors';
export type ActionType = SettingsActionType;
export { actionTypes, actionCreators };
export default reducer;
